const getters = {
  photo_profile: (state) => {
    return state.userdata ? state.userdata.profile_picture : 'https://cdn-icons-png.flaticon.com/512/149/149071.png'
  },
  logistic_company: (state) => {
    return state.userdata ? state.userdata.logistic_company : null
  },
  locale: (state) => {
    return state.locale
  }
}

export default getters
